// helpers/evaluateLogic.js

const checkCondition = (fieldValue, operator, comparisonValue) => {
  switch (operator) {
    case 'equal': return fieldValue === comparisonValue;
    case 'notequal': return fieldValue !== comparisonValue;
    case 'greater': return parseFloat(fieldValue) > parseFloat(comparisonValue);
    case 'greatequal': return parseFloat(fieldValue) >= parseFloat(comparisonValue);
    case 'less': return parseFloat(fieldValue) < parseFloat(comparisonValue);
    case 'lessequal': return parseFloat(fieldValue) <= parseFloat(comparisonValue);
    case 'contains': return (fieldValue || '').includes(comparisonValue);
    case 'notcontain': return !(fieldValue || '').includes(comparisonValue);
    case 'empty': return !fieldValue;
    case 'notempty': return !!fieldValue;
    default: return false;
  }
};

const normalizeLogic = (logicRules) => {
  if (!Array.isArray(logicRules)) return [];
  return logicRules.map(block => Array.isArray(block) ? block : [block]);
};

const evaluateLogic = (logicRules, values) => {
  if (!Array.isArray(logicRules)) return true;

  const normalizedRules = normalizeLogic(logicRules);

  return normalizedRules.every((block, blockIndex) => {
    return block.some((rule, ruleIndex) => {
      const fieldValue = values[rule.field];
      const result = checkCondition(fieldValue, rule.operator, rule.value);
      // console.log(`🔍 Rule[${blockIndex}][${ruleIndex}]`, rule, "→", result, "(value:", fieldValue, ")");
      return result;
    });
  });
};


export default evaluateLogic;
